module.exports = __webpack_public_path__ + "img/9788957515495.14c957ad.jpg";